import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, switchMap } from 'rxjs';
import { SweetAlertService } from '../sweetalert/sweet-alert.service';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { decryptClientDetails } from '../../shared/crypto-js/crypto-js';
import { decrypt } from '../../shared/crypto-js/decrypt';

@Injectable({
  providedIn: 'root'
})
export class UserDataService {

  userData: any;
  userPortfolio: any;
  loading = false;

  constructor(
    private http: HttpClient,
    private sweetAlertService: SweetAlertService,
    private router: Router,
  ) { }

  getUserData(): Observable<any> {
    if (this.router.url.includes('/verified-pnl')) {
      return of(null);
    }

    const formData = new FormData();
    formData.append('required_data', 'name,email,mobile,dpId,type,dpAccountNumber,pan,address,poa');

    return this.getClientDetails(formData).pipe(
      switchMap((data) => {
        if (data.status === "success" && data.result) {
          localStorage.setItem('userData', data.result);
          // localStorage.setItem('userData', "9fl6Orp17HdZ11Km/JYC2kUxifwtGVdqDSyt/52GWmRINbuKnxt/LAdUfos/i09ww+xoQG0qj2leTJaZoK9GH8LwYbo7aiSdv4aHgnUJ7/Uh53qKuqzkrPToffWTc1BaG5gCDp0Eqiuf9W4grrCRnbVMNXudpq5gTOWOLHbEkggfLNS8N9P/Ld+heKEeMKuVA2G8jTi988TQJ3r6pIcIdVrNiKTQFqY8JlZJqasWOq0N2dk4QYLDVvmRab1eykppTKBcJEGonmCFSK6K7NtZeX1rMFJgu3fR2bLUg7fcqXxWZsswSmd1mzFNXfZkK+ETf6i7Nvw46kI4BTcQBKyZ4TX7nrbA+Q21lh728f6/X0AOpxTebrCnLck03mEx/K6wSDcRzBZ3eR2kPa5+SjUSnA==");
          const currentTime = new Date().getTime();
          localStorage.setItem('userDataTime', currentTime.toString());

          const decrypted = decrypt(data.result);
          const userData = JSON.parse(decrypted);
          return of(userData);
        } else {
          this.sweetAlertService.sweetAlert("error", data.message || "Something went wrong");
          return of(null);
        }
      })
    );
  }

  decrypt(encryptedData: string): string {
    return decryptClientDetails(encryptedData);
  }

  getClientDetails(formData: any): Observable<any> {
    return this.http.post(`/getClientDetails`, formData);
  }

}
